import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { MsalService } from '@azure/msal-angular'
import { Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { UserService } from '../services/user-service/user-service.service'

@Injectable()
export class GlobalHttpInterceptorService implements HttpInterceptor {
  constructor(
    public router: Router,
    private userService: UserService,
    private msalService: MsalService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse) {
          switch (error.status) {
            case 401:
              if (this.hasNoMsalAccount()) {
                this.userService.ClearSession()
              }
              this.router.navigateByUrl('/login')
              break
          }
        } else {
          // A client-side or network error occurred. Handle it accordingly.
        }
        // Throw the error so that the next item in the chain (e.g. the component) can handle any other HTTP error
        throw error
      }),
    )
  }

  private hasNoMsalAccount(): boolean {
    try {
      return this.msalService.instance.getAllAccounts().length === 0
    } catch {
      return false
    }
  }
}
